import { valueOrNA } from 'Common/valueOrNA';
import { formatMake } from 'utils/make';
import { toCapitalize } from 'Common/string';

export const getDerivativeDisplayName = derivative =>
  toCapitalize(
    `${formatMake(valueOrNA(derivative, 'make'))} ${valueOrNA(
      derivative,
      'range'
    )} ${valueOrNA(derivative, 'name')}`
  );



// WEBPACK FOOTER //
// ./src/utils/derivative/index.js